import "./Typography.d";

import type { TypographyProps as MuiTypographyProps } from "@mui/material/Typography";

import MuiTypography from "@mui/material/Typography";
import React, { ElementType } from "react";

import Styles from "./Typography.module.scss";

export interface TypographyProps
    extends Pick<MuiTypographyProps, "className" | "children" | "variant" | "align"> {
    color?:
        | "primary"
        | "primaryLink"
        | "secondary"
        | "error"
        | "warning"
        | "info"
        | "success"
        | "inherit";
    component?: ElementType;
    fontWeight?: 400 | 600;
    maxLines?: number;
    /**
     * Applies the theme typography styles.
     * @default 'text'
     */
    variant?:
        | "text"
        | "text-sm"
        | "text-xs"
        | "title"
        | "title-sm"
        | "title-xs"
        | "label"
        | "helper-text"
        | "menu-label";
}

export const Typography = React.memo(
    ({
        children,
        className,
        color,
        component = "p",
        fontWeight,
        maxLines,
        variant = "text",
        ...rest
    }: TypographyProps) => {
        const lineClampStyle = maxLines
            ? ({
                  "--lines": maxLines,
              } as React.CSSProperties)
            : undefined;

        return (
            <MuiTypography
                className={`${Styles[variant]} ${
                    fontWeight ? Styles[`font-weight-${fontWeight}`] : ""
                } ${className || ""} ${maxLines ? Styles["line-clamp"] : ""}`}
                color={color ? `${color}.main` : undefined}
                component={component}
                style={lineClampStyle}
                {...rest}
            >
                {children}
            </MuiTypography>
        );
    },
);

Typography.displayName = "Typography";
